import type { Store } from "redux";
import type { GlobalState } from "storefront/GlobalState";
import createApp from "../../containers/home";
import NavOverlay from "./NavOverlay";

const render = (node: HTMLElement, store: Store<GlobalState>) =>
  createApp(node, NavOverlay, store);

export default render;
